export default "__VITE_ASSET__BFtpRIMy__"